import { render } from "./commentsEditor.vue?vue&type=template&id=993d5102&scoped=true"
import script from "./commentsEditor.vue?vue&type=script&lang=js"
export * from "./commentsEditor.vue?vue&type=script&lang=js"

import "./commentsEditor.vue?vue&type=style&index=0&id=993d5102&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-993d5102"]])

export default __exports__